var exports = {
  "Q": "xe7b6e3d6--4dba39--content",
};

module.exports = exports;
